import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import Spinner2 from "../../components/Spinner2";
import MainButton, {
  BackButton,
} from "../../components/common/MainButtonComponent";
import { routes } from "../../helper/routes";
import "./AssessShared.css";
import "./ExamSection.css";
import {
  ExamGradingProvider,
  useExamGradingContext,
} from "../../context/Exam/ExamGradingContext";

function ExamGradeReportContent({ exam = {}, onBack, history }) {
  const [pageReady, setPageReady] = useState(false);
  const [assessmentDetails, setAssessmentDetails] = useState(null);
  const {
    report,
    reportLoading,
    reportError,
    loadReport,
    questionMix,
    loadGradingPaper,
    loadGradeScales,
    getGradeByPercentage,
  } = useExamGradingContext();


  const finalGrade = report?.final_grade ?? exam?.final_grade ?? null;

  const attemptText = `${exam?.attempt_no || report?.attempt_no || 1}/${exam?.no_of_attempts || report?.no_of_attempts || 1}`;

  const attemptedDate =
    report?.attempt_start_time ||
    report?.attempt_end_time ||
    exam?.attempt_start_time ||
    exam?.attempt_end_time ||
    exam?.start_time ||
    "-";

  const formattedAttemptedDate =
    attemptedDate === "-"
      ? "-"
      : new Date(`${attemptedDate}Z`).toLocaleString();

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setPageReady(false);

      try {
        if (!exam?.candidate_id) return;

        await loadGradeScales();
        await loadReport(exam);

        if (exam?.assessment_id || exam?.id) {
          const gradingData = await loadGradingPaper(exam);
          if (!cancelled) {
            setAssessmentDetails(gradingData?.assessment_details || null);
          }
        }
      } finally {
        if (!cancelled) {
          setPageReady(true);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [
    exam?.candidate_id,
    exam?.attempt_no,
    exam?.assessment_id,
    exam?.id,
  ]);
  const obtainedMarks =
    report?.total_mark_obtained ??
    report?.final_grade ??
    exam?.total_mark_obtained ??
    exam?.final_grade ??
    null;

  const totalMarks =
    report?.total_mark_allocation ??
    exam?.total_mark_allocation ??
    questionMix.totalMarkAllocation ??
    100;

  const scheduleSource = assessmentDetails || exam;

  const percentage =
    obtainedMarks == null || !Number(totalMarks)
      ? null
      : Math.round((Number(obtainedMarks) / Number(totalMarks)) * 100);

  const gradeScale = percentage == null ? null : getGradeByPercentage(percentage);

  const marksText = percentage == null ? "Not Graded" : `${percentage}/100`;
  const hasGrade = percentage !== null;
  const isMcqOnly = questionMix.isMcqOnly;
  const canSelfGrade = !isMcqOnly;
  const canViewResultSheet = hasGrade;
  return (
    <ContentWrapper>
      <section className="exam-report-page">
        <div className="exam-report-back">
          <BackButton
            label=""
            title="Back"
            onClick={onBack}
          />
        </div>

        {reportError && <p className="text-danger">{reportError}</p>}

        {(!pageReady || reportLoading) && <Spinner2 text="Loading" />}

        {pageReady && !reportLoading && !reportError && (
          <div className="exam-report-card">
            <div className="exam-report-hero">
              <div className="exam-report-heading">
                <span>My Report</span>
                <h1>{exam?.name || exam?.title || "Grade Report"}</h1>
              </div>

              <div className="exam-report-score">
                <strong className={percentage == null ? "exam-report-score__pending" : ""}>
                  {percentage == null ? "Not Graded" : percentage}
                </strong>
                <span>Grade {gradeScale?.grade || report?.grade || "-"}</span>
              </div>
            </div>

            <div className="exam-report-details-grid row g-3">
              <div className="col-12 col-md-6">
                <div className="exam-report-detail-item">
                  <span>Marks :</span>
                  <strong>{marksText}</strong>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="exam-report-detail-item">
                  <span>Attempt Number :</span>
                  <strong>{attemptText}</strong>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="exam-report-detail-item">
                  <span>Paper Duration :</span>
                  <strong>
                    {(report?.is_set_time_limit ?? exam?.is_set_time_limit)
                      ? `${report?.exam_time_interval ?? exam?.exam_time_interval ?? 0} ${
                          Number(report?.exam_time_interval_unit_id ?? exam?.exam_time_interval_unit_id) === 2
                            ? "Hours"
                            : Number(report?.exam_time_interval_unit_id ?? exam?.exam_time_interval_unit_id) === 3
                            ? "Days"
                            : Number(report?.exam_time_interval_unit_id ?? exam?.exam_time_interval_unit_id) === 4
                            ? "Months"
                            : "Minutes"
                        }`
                      : "Unlimited"}
                  </strong>
                </div>
              </div>

              <div className="col-12 col-md-6">
                <div className="exam-report-detail-item">
                  <span>Paper Attempted Date :</span>
                  <strong>{formattedAttemptedDate}</strong>
                </div>
              </div>
            </div>

            <div className="exam-report-actions">
              {canSelfGrade && (
                <MainButton
                  action="edit"
                  icon="edit"
                  label="Self grading"
                  tone="success"
                  // onClick={() =>
                  //   history.push({
                  //     pathname: routes.exm_self_grading.replace(":id", exam.candidate_id),
                  //     search: `?assessment_id=${exam.assessment_id || exam.id}&attempt_no=${exam.attempt_no}`,
                  //     state: { exam },
                  //   })
                  // }
                  onClick={() => {
                    const selfGradingExam = {
                      ...exam,
                      assessment_id: exam.assessment_id || exam.id,
                      attempt_no: exam.attempt_no || report?.attempt_no || 1,
                      attempt_start_time:
                        report?.attempt_start_time ||
                        exam?.attempt_start_time ||
                        exam?.start_time ||
                        null,
                    };

                    console.log(
                      "SELF GRADING navigation exam",
                      JSON.stringify(selfGradingExam, null, 2)
                    );

                    history.push({
                      pathname: routes.exm_self_grading.replace(":id", exam.candidate_id),
                      search: `?assessment_id=${selfGradingExam.assessment_id}&attempt_no=${selfGradingExam.attempt_no}`,
                      state: { exam: selfGradingExam },
                    });
                  }}
                />
              )}

              <MainButton
                action="view"
                icon="view"
                label="View result sheet"
                disabled={!canViewResultSheet}
                onClick={() =>
                  history.push({
                    pathname: routes.exm_result_sheet.replace(":id", exam.candidate_id),
                    search: `?assessment_id=${exam.assessment_id || exam.id}&attempt_no=${exam.attempt_no || 1}`,
                    state: { exam },
                  })
                }
              />

              {/* <MainButton
                action="download"
                icon="download"
                label="Download PDF"
              /> */}
            </div>
          </div>
        )}
      </section>
    </ContentWrapper>
  );
}

export default function ExamGradeReportPage({ exam: propExam, onBack }) {
  const history = useHistory();
  const location = useLocation();
  const { id } = useParams();

  const query = new URLSearchParams(location.search);

  const exam =
    propExam ||
    location.state?.exam || {
      candidate_id: Number(id),
      attempt_no: Number(query.get("attempt_no") || 1),
      assessment_id: Number(query.get("assessment_id") || 0),
    };

  return (
    <ExamGradingProvider>
      <ExamGradeReportContent
        exam={exam}
        onBack={onBack || (() => history.push({ pathname: routes.exm, state: { examView: "grade-reports" } }))}
        history={history}
      />
    </ExamGradingProvider>
  );
}
